export default {
      id: "phone-usage",
      viewBox: "0 0 28 36",
      url: __webpack_public_path__ + "../../sprite.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }